// Function to switch models (previously tabs)
window.switchToTab = function switchToTab(element) {
    // Get the element that triggered the function (form or button)
    let modelId;
    
    if (element && element.preventDefault) {
        // If called from an event, prevent default behavior
        element.preventDefault();
        modelId = element.target.getAttribute("data-tab-id") || element.target.getAttribute("data-target-model");
    } else if (element) {
        // If called with an element directly
        modelId = element.getAttribute("data-tab-id") || element.getAttribute("data-target-model");
    }

    if (!modelId) {
        // console.log("No model ID specified");
        return false; // Prevent form submission
    }

    // Use the global showModel function if available
    if (typeof window.showModel === 'function') {
        window.showModel(modelId);
        return false;
    }

    // Fallback: Direct model switching
    const modelContainer = document.getElementById('modelContainer');
    if (!modelContainer) {
        console.error('Model container not found');
        return false;
    }

    const targetModel = modelContainer.querySelector(`[data-model="${modelId}"]`);
    if (!targetModel) {
        // console.log('Model not found:', modelId);
        return false;
    }

    // Get current active model for animation
    const currentActiveModel = modelContainer.querySelector('[data-model][data-state="show"]');
    
    // Animate out current model if exists
    if (currentActiveModel && currentActiveModel !== targetModel) {
        gsap.to(currentActiveModel, {
            opacity: 0,
            duration: 0.25,
            ease: "power1.out",
            onComplete: function() {
                // Hide all models
                const allModels = modelContainer.querySelectorAll('[data-model]');
                allModels.forEach(model => {
                    model.setAttribute('data-state', 'hide');
                });
                
                // Show the target model
                targetModel.setAttribute('data-state', 'show');
                
                // Animate in new model with form elements
                animateModelTransition(targetModel);
            }
        });
    } else {
        // No current model or same model, just show new one
        const allModels = modelContainer.querySelectorAll('[data-model]');
        allModels.forEach(model => {
            model.setAttribute('data-state', 'hide');
        });
        targetModel.setAttribute('data-state', 'show');
        animateModelTransition(targetModel);
    }
    
    return false; // Prevent form submission
}

// Function to animate model transition with form elements
function animateModelTransition(modelPane) {
    const formContainer = modelPane.querySelector('.form-container');
    
    if (!formContainer) {
        // Simple fade in if no form container
        gsap.fromTo(modelPane, 
            { opacity: 0 },
            { opacity: 1, duration: 0.3 }
        );
        return;
    }

    // Get all animatable elements in order
    const formHeader = formContainer.querySelector('.form-header');
    const formBody = formContainer.querySelector('.form-body');
    
    // Collect all animatable elements from form body in order
    let allAnimatableElements = [];
    
    if (formBody) {
        // Get all direct children and nested elements that should animate
        const carousels = formBody.querySelectorAll('.carousel, #offersCarousel');
        const images = formBody.querySelectorAll('img:not(.carousel img):not(.carousel-inner img)');
        const validityBoxes = formBody.querySelectorAll('.border:has(.event-date-box), .border:has(.event-time-box), .border:has(.validity-box)');
        const totalDaysBox = formBody.querySelector('#inviteDays');
        const formGroups = formBody.querySelectorAll('.form-group, .row:has(.form-group):not(:has(.event-date-box)):not(:has(.event-time-box)):not(:has(.validity-box)):not(#inviteDays), .mb-3:has(.form-control)');
        
        // Combine all elements in the order they appear in the DOM
        allAnimatableElements = [
            ...carousels,
            ...images,
            ...validityBoxes,
            ...(totalDaysBox ? [totalDaysBox] : []),
            ...formGroups
        ].filter(el => el && formBody.contains(el));
    }
    
    const formButtons = formContainer.querySelector('.form-footer');

    // Create timeline for smooth sequential animation
    const tl = gsap.timeline({
        defaults: {
            ease: "power2.out",
            duration: 0.5
        },
        onComplete: () => {
            // Clear inline styles after animation but preserve overflow and border-radius
            allAnimatableElements.forEach(el => {
                gsap.set(el, { clearProps: "opacity,y,transform,x,scale" });
            });
            gsap.set([modelPane, formHeader, formButtons], { clearProps: "all" });
        }
    });

    // Fade in the model pane first
    tl.fromTo(modelPane, 
        { opacity: 0 },
        { opacity: 1, duration: 0.3 }, 
        0
    );

    // Animate header
    if (formHeader) {
        tl.fromTo(formHeader, 
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 0.4 }, 
            0.1
        );
    }

    // Animate all body elements with consistent stagger
    if (allAnimatableElements.length > 0) {
        tl.fromTo(allAnimatableElements, 
            { opacity: 0, y: 30 },
            { 
                opacity: 1, 
                y: 0,
                stagger: 0.1,
                duration: 0.6,
                ease: "power3.out"
            }, 
            0.3
        );
    }

    // Animate footer buttons last with gentle bounce
    if (formButtons) {
        tl.fromTo(formButtons, 
            { opacity: 0, y: 20 },
            { 
                opacity: 1, 
                y: 0,
                duration: 0.5,
                ease: "back.out(1.5)",
                onComplete: function() {
                    // Check if this is the RSVP tab and initialize it
                    const modelType = modelPane.getAttribute('data-model');
                    if (modelType === 'rsvp-tab') {
                        if (typeof window.initializeRSVPFormBuilder === 'function') {
                            setTimeout(() => {
                                if (typeof window.loadRSVPFormData === 'function') {
                                    window.loadRSVPFormData();
                                }
                                if (typeof window.initializeGuestCountControls === 'function') {
                                    window.initializeGuestCountControls();
                                }
                                if (typeof window.attachRSVPFormListeners === 'function') {
                                    window.attachRSVPFormListeners();
                                }
                            }, 100);
                        }
                    }
                }
            }, 
            "-=0.3"
        );
    } else {
        // If no form buttons, still check for RSVP tab after animation
        tl.call(function() {
            const modelType = modelPane.getAttribute('data-model');
            if (modelType === 'rsvp-tab') {
                if (typeof window.initializeRSVPFormBuilder === 'function') {
                    setTimeout(() => {
                        if (typeof window.loadRSVPFormData === 'function') {
                            window.loadRSVPFormData();
                        }
                        if (typeof window.initializeGuestCountControls === 'function') {
                            window.initializeGuestCountControls();
                        }
                        if (typeof window.attachRSVPFormListeners === 'function') {
                            window.attachRSVPFormListeners();
                        }
                    }, 100);
                }
            }
        }, null, "+=0");
    }
}

// Navigate to next model function for dynamic navigation
window.navigateToNextTab = function navigateToNextTab(form) {
    const modelId = form.getAttribute('data-tab-id') || form.getAttribute('data-target-model');
    if (modelId) {
        // If navigating to login-tab, store form data in session
        if (modelId === 'login-tab') {
            // Switch to tab immediately for better UX
            if (typeof window.showModel === 'function') {
                window.showModel(modelId);
            } else {
                switchToTab({ getAttribute: () => modelId });
            }
            
            // Store form data in background (don't wait)
            storeFormDataToSession().then(() => {
                console.log('Form data stored to session after tab switch');
            }).catch(error => {
                console.error('Failed to store form data:', error);
            });
            
            return false;
        }
        
        if (modelId === 'payment-tab') {
            // Save RSVP data before navigating to payment if coming from RSVP tab
            const currentModel = document.querySelector('[data-model][data-state="show"]');
            if (currentModel && currentModel.getAttribute('data-model') === 'rsvp-tab') {
                // console.log('Saving RSVP data before navigating to payment');
                if (typeof window.saveRSVPFormData === 'function') {
                    window.saveRSVPFormData();
                }
            }
            
            // Switch to tab and show loading immediately
            continueToPayment();
            
            // Update draft in background (don't wait)
            // updateDraftOnPayment().then(() => {
            //     console.log('Draft updated after tab switch');
            // }).catch(error => {
            //     console.error('Failed to update draft:', error);
            // });
            
            return false;
        } else {
            let payPulishBtnBox =  document.querySelector("#paymentPublishBtnBox");
            payPulishBtnBox.innerHTML = ``;
        }
        
        // For all other tabs, switch normally
        if (typeof window.showModel === 'function') {
            window.showModel(modelId);
        } else {
            switchToTab({ getAttribute: () => modelId });
        }
    }
    return false;
}

// Helper function to continue to payment
function continueToPayment() {
    const modelId = 'payment-tab';
    
    // Clear payment container
    const paymentContainer = document.getElementById("paymentContainer");
    if (paymentContainer) {
        paymentContainer.innerHTML = `
            <div class="container d-flex justify-content-center align-items-center h-100">
                <!-- Loading Spinner -->
                <div class="spinner-border text-dark" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>`;
    }
    
    if (typeof window.processToPayment === 'function') {
        window.processToPayment();
    } else {
        console.error('processToPayment function not available');
    }
    
    if (typeof logMetadata === 'function') {
        logMetadata();
    }
    
    // Use showModel if available, otherwise fallback to switchToTab
    if (typeof window.showModel === 'function') {
        window.showModel(modelId);
    } else {
        switchToTab({ getAttribute: () => modelId });
    }
}


// Function to store form data to session before login
async function storeFormDataToSession() {
    try {
        // Check if we're in update mode - don't store to session/draft when updating
        const bodyElement = document.querySelector('body');
        const currentPage = bodyElement ? bodyElement.getAttribute('data-cp') : null;
        
        if (currentPage === 'update-invite' || currentPage === 'update') {
            // console.log('Update mode detected - skipping session storage');
            return { success: true, skipped: true, reason: 'update_mode' };
        }
        
        // Collect data from all three forms
        const formData = {};
        
        // Get template ID from page context
        const templateIdElement = document.querySelector('[data-template-id]');
        const templateId = templateIdElement ? templateIdElement.getAttribute('data-template-id') : null;

        const themeIdElement = document.querySelector('[data-theme-id]');
        const themeId = themeIdElement ? themeIdElement.getAttribute('data-theme-id') : null;
        
        // Collect details-tab data
        const detailsForm = document.querySelector('[data-model="details-tab"] form');
        if (detailsForm) {
            const detailsInputs = detailsForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            detailsInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Collect schedule-tab data
        const scheduleForm = document.querySelector('[data-model="schedule-tab"] form');
        if (scheduleForm) {
            const scheduleInputs = scheduleForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            scheduleInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Collect venue-tab data
        const venueForm = document.querySelector('[data-model="venue-tab"] form');
        if (venueForm) {
            const venueInputs = venueForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            venueInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Add template ID
        formData.template_id = templateId;
        formData.theme_id = themeId;
        
        // console.log('Storing form data to session:', formData);
        
        // Send data to server
        const response = await fetch('/api/store-invitation-data/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        
        const result = await response.json();
        
        // if (result.success) {
        //     console.log('Form data stored successfully in session');
        // } else {
        //     console.error('Failed to store form data:', result.error);
        // }
        
        return result;
    } catch (error) {
        console.error('Error storing form data to session:', error);
        throw error;
    }
}

// Function to retrieve stored form data from session
async function getStoredFormDataFromSession() {
    try {
        // Get template ID from page context
        const templateIdElement = document.querySelector('[data-template-id]');
        const templateId = templateIdElement ? templateIdElement.getAttribute('data-template-id') : null;
        
        // Build URL with template_id parameter for draft lookup
        let url = '/api/get-stored-invitation-data/';
        if (templateId) {
            url += `?template_id=${encodeURIComponent(templateId)}`;
        }
        
        const response = await fetch(url);
        const result = await response.json();
        
        if (result.success && result.data) {
            // console.log('Retrieved stored form data:', result.data, 'from', result.source || 'session');
            return result.data;
        }
        
        return null;
    } catch (error) {
        console.error('Error retrieving stored form data:', error);
        return null;
    }
}

// Function to restore form data after login
window.restoreFormDataAfterLogin = async function() {
    try {
        const storedData = await getStoredFormDataFromSession();
        
        if (!storedData) {
            // console.log('No stored form data to restore');
            return;
        }
        
        // Restore details-tab data
        if (storedData) {
            const detailsForm = document.querySelector('[data-model="details-tab"] form');
            if (detailsForm) {
                Object.keys(storedData).forEach(key => {
                    const input = detailsForm.querySelector(`[data-theme-key="${key}"], [name="${key}"]`);
                    if (input && storedData[key]) {
                        input.value = storedData[key];
                    }
                });
            }
        }
        
        // Restore schedule-tab data
        if (storedData) {
            const scheduleForm = document.querySelector('[data-model="schedule-tab"] form');
            if (scheduleForm) {
                Object.keys(storedData).forEach(key => {
                    const input = scheduleForm.querySelector(`[data-theme-key="${key}"], [name="${key}"]`);
                    if (input && storedData[key]) {
                        input.value = storedData[key];
                    }
                });
            }
        }
        
        // Restore venue-tab data
        if (storedData) {
            const venueForm = document.querySelector('[data-model="venue-tab"] form');
            if (venueForm) {
                Object.keys(storedData).forEach(key => {
                    const input = venueForm.querySelector(`[data-theme-key="${key}"], [name="${key}"]`);
                    if (input && storedData[key]) {
                        input.value = storedData[key];
                    }
                });
            }
        }
        
        // Trigger form data storage to update localStorage and iframe
        if (window.formDataStorage) {
            window.formDataStorage.saveFormData(storedData);
        }
        
        // console.log('Form data restored successfully');
        
        // Clear the session data after restoration
        await fetch('/api/clear-stored-invitation-data/', { method: 'POST' });
    } catch (error) {
        console.error('Error restoring form data:', error);
    }
}

// Function to update draft invitation on payment-tab
async function updateDraftOnPayment() {
    try {
        // Check if we're in update mode - don't update draft when updating existing invitation
        const bodyElement = document.querySelector('body');
        const currentPage = bodyElement ? bodyElement.getAttribute('data-cp') : null;
        
        if (currentPage === 'update-invite' || currentPage === 'update') {
            // console.log('Update mode detected - skipping draft update');
            return { success: true, skipped: true, reason: 'update_mode' };
        }
        
        // Collect data from all three forms
        const formData = {};
        
        // Get template ID from page context
        const templateIdElement = document.querySelector('[data-template-id]');
        const templateId = templateIdElement ? templateIdElement.getAttribute('data-template-id') : null;
        
        if (!templateId) {
            console.warn('Template ID not found, cannot update draft');
            return;
        }
        
        // Collect details-tab data
        const detailsForm = document.querySelector('[data-model="details-tab"] form');
        if (detailsForm) {
            const detailsInputs = detailsForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            detailsInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Collect schedule-tab data
        const scheduleForm = document.querySelector('[data-model="schedule-tab"] form');
        if (scheduleForm) {
            const scheduleInputs = scheduleForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            scheduleInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Collect venue-tab data
        const venueForm = document.querySelector('[data-model="venue-tab"] form');
        if (venueForm) {
            const venueInputs = venueForm.querySelectorAll('input[data-theme-key], textarea[data-theme-key], select[data-theme-key]');
            venueInputs.forEach(input => {
                const key = input.getAttribute('data-theme-key') || input.name;
                if (key) {
                    formData[key] = input.value;
                }
            });
        }
        
        // Add template ID
        formData.template_id = templateId;
        
        // console.log('Updating draft on payment:', formData);
        
        // Send data to server
        const response = await fetch('/api/update-draft-on-payment/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        
        const result = await response.json();
        
        // if (result.success) {
        //     console.log('Draft updated successfully:', result.draft_uid);
        // } else {
        //     console.error('Failed to update draft:', result.error);
        // }
        
        return result;
    } catch (error) {
        console.error('Error updating draft on payment:', error);
        throw error;
    }
}

// Expose functions globally
window.storeFormDataToSession = storeFormDataToSession;
window.getStoredFormDataFromSession = getStoredFormDataFromSession;
window.updateDraftOnPayment = updateDraftOnPayment;

// Expose animateModelTransition globally for use in other modules
window.animateModelTransition = animateModelTransition;
